export const h = {
	quantity: "en stock",
	brand: "marque",
	sku: "SKU",
	model: "maquette",
	addCart: "ajouter au panier",
	buyNow: "Acheter maintenant",
	productDetail: "détails du produit",
	attribute: "Attribute",
	quantityExits: "En stock",
	quantityNone: "En rupture de stock",

	// 账单页面
	email: "E-mail",
	errorEmail: "Veuillez saisir une adresse e-mail correcte.",
	contact: 'Coordonnées',
	sippingAddress: 'Adresse de livraison',
	name: "Nom",
	nameError: "Veuillez entrer votre nom",
	address1: "adresse1",
	address1Error: "Veuillez entrer l'adresse1",

	address2: "Adresse 2",
	emailCode: "code postal",

	phone: "numéro de téléphone portable",
	city: "ville",
	cityError: "Veuillez entrer la ville",
	country: "Pays",
	countryError: "Veuillez entrer le pays",
	province: "province",
	provinceError: "Veuillez saisir la province",
	payWay: "Mode de paiement",
	sendWay: "Mode de livraison",
	loginText: "Se connecter / S'inscrire",
	cartNum: "Nombre total de paniers",
	orderRemarks: "Remarques de commande",
	discountCode: "Veuillez saisir le code de réduction",
	apply: "Utiliser",
	submitOrder: "Soumettre la commande",

	classify: "Catégorie",
	price: "Prix",
	allNum: "Total",
	defaultTit: "Par défaut",
	salesLowToHigh: "Ventes (Bas - Haut)",
	salesHighToLow: "Ventes (Haut - Bas)",
	nameAtoZ: "Nom (A - Z)",
	nameZtoA: "Nom (Z - A)",
	priceLowtoHeight: "Prix (Bas - Haut)",
	priceHeighttoLow: "Prix (Haut - Bas)",
	selectClassfiy: "Sélectionner une catégorie",
	goodCart: "Panier",
	checkout: "Commander",
	pay: "Payer",
	goods: "Produit",
	num: "Quantité",
	total: "Sous-total",
	action: "Action",
	del: "Supprimer",
	priceTotal: "Total",
	all: "Tous",
	selectd: "Sélectionné",
	goCheckout: "Passer commande",
	linkGoods: "Produits associés",
	noData: "Aucune donnée disponible",
	myOrder: "Mes commandes",
	changeUserInfo: "Modifier mes informations",
	changePassword: "Changer le mot de passe",
	myAddress: "Mes adresses",
	myWishlist: "Ma liste de souhaits",
	myRmas: "Mon SAV",
	userCommission: "Commission membre",
	commissionUsers: "Relations membres",
	loginOut: "Se déconnecter",
	orderId: "Numéro de commande",

	lookDetail: "Voir détails",
	saleService: "Demander SAV",
	confirmReceivedGoods: "Confirmer réception",
	goPay: "Payer",
	cancelOrder: "Annuler commande",

	orderDetail: "Détails commande",
	created_at: "Date de création",
	status_format: "Statut commande",
	total_format: "Montant commande",
	payment_method_name: "Moyen de paiement",
	shipping_method_name: "Mode de livraison",

	addressInfo: "Adresse",
	name: "Nom",
	address: "Adresse",
	payGoods: "Produits commandés",

	sendCompany: "Transporteur",
	sendNum: "Numéro de suivi",
	updateTime: "Date mise à jour",
	memo: "Remarques",
	payOrderAddress: "Adresse de facturation",
	allOrder: "Toutes commandes",
	waitPay: "Paiement en attente",
	waitSend: "Expédition en attente",
	waitReceiving: "Livraison en attente",
	completed: "Terminé",
	confirm: "Confirmer",
	tips: "Astuce",
	cancel: "Annuler",
	changeHeadImg: "Changer photo profil",
	uploadTit: "Uploader image JPEG/PNG. Taille conseillée : 300 x 300.",
	imgSizeTips: "Taille max. 2 Mo !",
	imgTypeTips: "Formats JPG/PNG uniquement !",
	serviceType: "Type service",
	returnNum: "Quantité retour/échange",
	isOpend: "Emballage ouvert ?",
	returnReason: "Motif retour",
	yes: "Oui",
	no: "Non",
	returnGoods: "Retour",
	exchange: "Échange",
	repair: "Réparation",
	reissue: "Renvoi",
	refund: "Remboursement",
	returnNumError: "Saisir quantité retour",

	oldPassword: "Ancien mot de passe",
	newPassword: "Nouveau mot de passe",
	confirmNewPassword: "Confirmer mot de passe",

	wishlist: "Retirer de ma liste",
	look: "Voir",
	opendPkg: "Emballage ouvert",
	img: "Image",
	afterSales: "Détails SAV",

	balance: "Solde disponible",
	waitAmount: "Montant en attente",
	withdrawaled: "Retiré",
	withdrawal: "Retrait",
	allCommission: "Commission totale",
	startTime: "Date début",
	endTime: "Date fin",
	search: "Rechercher",

	rebateLevel: "Niveau remise",
	CommissionRate: "Taux commission",
	commission: "Commission",
	settlementStatus: "Statut règlement",
	time: "Date",
	WithdrawalAmount: "Montant retrait",
	peleaseSelect: "Sélectionner",
	withdrawalUser: "Compte retrait",
	peleaseIpt: "Saisir",
	submitSuccess: "Envoyé avec succès",
	shareLink: "Partager lien",
	superior: "Mon supérieur",
	wu: "Aucun",
	subordinate: "Mes subordonnés",
	addTime: "Date d'adhésion",
	userAccount: "Compte",
	recommendationCode: "Code parrainage",
	copySuccess: "Copié avec succès",
	subPay: "Valider paiement",
	iptCardholder_Name: "Saisir nom titulaire",

	copy: "copie",

	"home": "Accueil",
	"categoriesPage": "Catégories",
	"brandsPage": "Marques",
	"brandsPageList": "Produits de marque",
	"productsPage": "Produits",
	"wishlistPage": "Ma liste de souhaits",
	"accountPage": "Mes commandes",
	"cartsPage": "Panier",
	"checkoutPage": "Paiement",
	"passwordPage": "Modifier le mot de passe",
	"editPage": "Modifier les informations",
	"addressesPage": "Modifier l'adresse",
	"rmasPage": "Relations de membres",
	"commissionPage": "Commission de membre",
	"success_order_checkoutPage": "Paiement de commande",
	"page_categoriesPage": "Catégories d'articles",
	"userloginPage": "Connexion",
	"pagesPage": "Articles",

	hotGoods: "Produits tendance",
	newGoods: "Nouveautés",
	visitGoods: "Les plus consultés",
	allGoods: "Tous les produits",
	evaluation: "Avis",

	"first_name": "Nom",
	"first_nameError": "Veuillez saisir votre nom",
	"last_name": "Prénom",
	"last_nameError": "Veuillez saisir votre prénom",

	"comment": "Contenu",
	"noContent": "Aucun commentaire pour l'instant",
	"author": "Auteur",
	"scoreNum": "Note",
	"commentTit": "Commentaires",

	send: "Envoyer",

	noPayWay: "Aucun moyen de paiement disponible",
	noTransportation: "Aucun mode de livraison disponible",

	"tkyouorder": "Merci pour votre commande",
	"orderDate": "Date de commande",
	"ordeAmount": "Montant de la commande",
	"paymentAddress": "Adresse de paiement",
	"zipCode": "Code postal",
	customizationFee: "Frais de personnalisation"
}